import { Component, OnInit } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { FormGroup } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatLabel } from '@angular/material/input';

@Component({
    selector: 'app-content',
    templateUrl: './label-text.component.html',
    styleUrls: ['./label-text.component.scss'],
    imports: [NgClass, MatLabel]
})
export class LabelTextComponent implements OnInit {

  public FormControlName;
  config: FieldConfig;
  group: FormGroup;

  constructor() {}

  ngOnInit() {
    this.FormControlName = this.config.name;
  }

}
